<div class="page-layout">
  <div class="kindergarten-data border-r-16" *transloco="let t">
    <ul class="nav" role="tablist">
      <li class="nav-item">
        <a (click)="selectTab(tabs.WORKPLACE, $event)" [class.active]="selectedTab === tabs.WORKPLACE" id="basic" role="tab">
          {{ t('settings/workplaceData') }}
        </a>
      </li>
      <li class="nav-item" *ngIf="authService.loggedUser?.teacher.isDirector()">
        <a (click)="selectTab(tabs.ORGANISATION, $event)" [class.active]="selectedTab === tabs.ORGANISATION" id="basic" role="tab">
          {{ t('settings/organisationData') }}
        </a>
      </li>
      <li class="nav-item">
        <a (click)="selectTab(tabs.TRAFFIC, $event)" [class.active]="selectedTab === tabs.TRAFFIC" id="education" role="tab">
          {{ t('settings/traffic') }}
        </a>
      </li>
    </ul>

    <div class="tab-content" [ngSwitch]="selectedTab">
      <ng-container *ngIf="authService.loggedUser?.teacher.isDirector()">
        <app-organisation-form *ngSwitchCase="tabs.ORGANISATION"></app-organisation-form>
      </ng-container>
      <app-workplace-form *ngSwitchCase="tabs.WORKPLACE"></app-workplace-form>
      <app-traffic-form *ngSwitchCase="tabs.TRAFFIC"></app-traffic-form>
    </div>
  </div>
</div>
